import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/backend";
import type { ConversationCreateInput } from "@/lib/backend/api";
import { CONVERSATION_QUERY_KEY } from "./conversation.query.key";

export function useCreateConversation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: ConversationCreateInput) => {
      const res = await api.conversationCrud.create(input);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CONVERSATION_QUERY_KEY] });
    },
  });
}
